<template>
  <p>Redirect</p>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "auth-redirect",
  data() {
    return {
      confirmPassword: ""
    };
  },
  created() {
    let search = window.location.search.split("&");
    let access_token = search[0].split("=")[1];
    let expires_in = +search[1].split("=")[1];
    let isFirstEnter = !!search[2];

    const data = {
      access_token,
      expires_in
    };

    this.enterUser({ res: data, isFirstEnter });
  },
  methods: {
    ...mapActions({
      enterUser: "user/enterUser"
    })
  }
};
</script>

<style scoped>
</style>
